/**
 * Use this module to exchange data between components
 * E.g. to bind something into App.vue from a routed component like Home.vue
 */
const state = {};

const actions = {};

const getters = {};

export default {
  state,
  actions,
  getters,
  namespaced: true,
};
